import React, { Component } from 'react'
import { PRODUCTIVITY_PROJECTS_LIST_URL } from '../assets/constants/constants';
import {  SEARCH_ICON,CLOSE } from "../assets/constants/Icons.js";
import {  USER_DATA, ACCESS_TOKEN } from "../assets/constants/constants";
import Toast from 'light-toast';

export class ProductivityAdminListPage extends Component {
    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN);

    constructor(props) {
        super(props)
        if (!this.sessionData) {
            Toast.loading("This component cannot be accessed directly. Redirecting to application home.", 3000, () => {
            });
            window.location = "/login";
            return;
        }
        
        this.state = {
            ideaList: [],
            originalProjectList: [],
            ideaNameSortIconRotate: false,
            ownerOHR: this.sessionData === null ? null : this.sessionData.profile.oHRId,
            ownerName: this.sessionData === null ? null : this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
            WhereClause: '',
            fetchProjectQuery:'',
           
        }
    }


    async componentDidMount() {
    }


    globalSearch = () => {
        let WhereClause = '';
        let fetchProjectQuery = '';

        if (this.state.globalsearchText) {
            WhereClause = `IdeaId like '${this.state.globalsearchText}' or IdeaIdAlpha like '${this.state.globalsearchText}' or LeanID like '${this.state.globalsearchText}'`;
            fetchProjectQuery = `pg_projectid eq '${this.state.globalsearchText}'`
            if (WhereClause !== '') {
                this.setState({
                    WhereClause: WhereClause,
                    fetchProjectQuery: fetchProjectQuery,
                }, async () => {
                    await this.fetchIdeas();
                })
            }
        }
        else {
            Toast.fail("Please type something then search.");
            return;
        }
    }

    refreshSearch = () => {
        window.location.reload();
    }
    
    fetchIdeas = () => {
        Toast.loading("Fetching projects...", () => { });
        return new Promise((resolve, reject) => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization":  "Bearer " + this.accessToken,
                }
            };
            fetch(`${PRODUCTIVITY_PROJECTS_LIST_URL}UserOHR=${123}&WhereClause=${this.state.WhereClause}&fetchProjectQuery=${this.state.fetchProjectQuery}`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    let leanData = data.LeanProject ? data.LeanProject :[];
                    let GBData = data.GBProject ? data.GBProject : [];

                    if(leanData.length === 0 && GBData.length === 0){
                        Toast.fail("Could not find the idea/project by that ID. Please enter a valid project ID", 5000,()=>{})
                        return;
                    }

                    let ideaConversionArray = [];
                    leanData && leanData.map((ideaItem, index) => {
                        ideaConversionArray.push({
                            // "pg_projectid": ideaItem.LeanID ? (ideaItem.LeanID !== "" ? ideaItem.LeanID : ideaItem.IdeaId) : ideaItem.IdeaId,
                            "pg_projectid": ideaItem.IdeaIDAlpha ? ideaItem.IdeaIDAlpha : "",
                            "LeanIDForDisplay": ideaItem.LeanID ? ideaItem.LeanID : ideaItem.IdeaIDAlpha,
                            "pg_projowner": ideaItem.OwnerName,
                            "pg_ownerohr": ideaItem.OwnerOHR,
                            "pg_account": ideaItem.AccountManual,
                            "msdyn_subject": ideaItem.IdeaName,
                            "pg_vertical": ideaItem.VerticalManual,
                            // "pg_projectstatus": ideaItem.WorkflowStatus,
                            "pg_worktypetxt": ideaItem.CertificationLevelName + " - " + ideaItem.TransformationLeverName,
                            "pg_projcreatedate": ideaItem.CreatedDate,
                            "pg_projectstate": ideaItem.ApprovalStatus,
                            "IdeaId": ideaItem.IdeaId,
                            "type": "idea",
                            "serviceLine": ideaItem.ServiceLineName,
                            "certificateLevel": ideaItem.CertificationLevelName,
                            "transformationLevel": ideaItem.TransformationLeverName,
                            "IsBestInClass": ideaItem.IsBestInClass,
                            "Region": ideaItem.RegionManual,
                            "AlphaIdeaID": ideaItem.IdeaIDAlpha,
                            "pg_mentor": (ideaItem.BlackBeltUserName === "" || ideaItem.BlackBeltUserName === null || ideaItem.BlackBeltUserName === undefined) ? ideaItem.pg_mentor : ideaItem.BlackBeltUserName,
                            "pg_region": (ideaItem.pg_region === "" || ideaItem.pg_region === undefined || ideaItem.pg_region === null) ? ideaItem.RegionManual : ideaItem.pg_region,
                            "pg_segment": ideaItem.Segment,
                            "pg_unit": ideaItem.Unit,
                        });
                        return true;
                    });
                    const projectArray = GBData && GBData;
                    const combinedArray = ideaConversionArray.concat(projectArray);
                    this.setState({
                        ideaList: combinedArray,
                    }, () => {
                        resolve();
                        Toast.hide();
                    })
                })
                .catch(error => {
                    Toast.fail("Could not fetch projects from backend:" + error, 3000, () => { });
                    console.log("Could not fetch projects from backend:" + error);
                    reject();
                });
        });
    }

    handleIdeaAction = (pg_projectid, IdeaId,LeanID) => {
        this.props.history.push({
            pathname: "/productivity-admin-details-page",
            state: [pg_projectid, IdeaId, LeanID]
        });
    }

    handleGlobalSearchFilterChange = (searchText) => {
        this.setState({
            globalsearchText: searchText,
            isTypedData: true,
            isTypedInGlobalSearch: true
        })
        if (searchText === '') {
            window.location.reload();
        }
    }
    

    formatDateString(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    render() {
        return (
            <>
                <div className='productivity_project_list_page_title_block'>
                    <h4 className="u-text">Productivity admin</h4>
                    <img src={require("../assets/images/listbanner.png")} alt="" style={{ width: '100%' }} />
                </div>
                <section className="u-clearfix u-section-1" id="sec-0f7f">
                    <div className="u-clearfix u-sheet u-sheet-1" style={{ marginBottom: 20, width: '100%' }}>
                        <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
                            <div className="u-container-layout u-container-layout-1 view-idea-table">
                                <div id="idea1" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                    <div className="u-container-layout u-container-layout-7">
                                        <div className="">
                                            <div className="" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                <div className="filter_search_block" style={{width:'228px'}}>
                                                    <input value={this.state.globalsearchText} onChange={(event) => this.handleGlobalSearchFilterChange(event.target.value)} placeholder="Search here" onKeyPress={event => {
                                                        if (event.key === 'Enter') {
                                                            this.globalSearch()
                                                        }
                                                    }}
                                                    />
                                                    <i style={{ marginTop: 9, position: 'absolute', color: '#001A30', marginLeft: -35, cursor: 'pointer' }} className={this.state.isTypedInGlobalSearch ? `${SEARCH_ICON} icon-style` : `${SEARCH_ICON} fa-disabled`} onClick={this.globalSearch} title="search"></i>
                                                    <i style={{ marginTop: 9, position: 'absolute', color: '#001A30', marginLeft: -15, cursor: 'pointer' }} className={this.state.isTypedInGlobalSearch ? `${CLOSE} icon-style` : `${CLOSE} fa-disabled`} onClick={this.refreshSearch} title="close"></i>
                                                </div>

                                            </div>
                                        </div>


                                        <div style={{ borderBottom: '1px solid lightgrey', marginBottom: 10 }} />


                                        <div className=" productivity_list_pages_table">
                                            <table className="table review-idea-table" style={{ fontSize: 12 }}>
                                                <thead style={{ textAlign: 'center !important' }} className="view-idea-thead">
                                                    <tr>
                                                        <th className="hidden-xs hidden-sm" scope="col">
                                                            Project ID
                                                        </th>
                                                        <th className="col-md-2 hidden-xs hidden-sm" style={{ maxWidth: "200px" }} scope="col" >
                                                            Project name
                                                        </th>
                                                        <th scope="col" onClick={() => this.handleProjectTypeSortClick("pg_worktypetxt")}>
                                                            Project type
                                                        </th>
                                                        <th className="col-md-1 hidden-xs hidden-sm" scope="col" >
                                                            State
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col" >
                                                            Status
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col" >
                                                            Project owner
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col">
                                                            Project mentor
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col">
                                                            Account name
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col">
                                                            Vertical
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col">
                                                            Region
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col">
                                                            Segment
                                                        </th>
                                                        <th className="hidden-xs hidden-sm" scope="col" >
                                                            Unit
                                                        </th>
                                                        <th scope="col" style={{ paddingLeft: 25, paddingRight: 25 }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="review-idea-tbody">
                                                    {
                                                        this.state.ideaList.length > 0 ? (
                                                            this.state.ideaList.map((ideaItem, index) => {
                                                              
                                                                return (
                                                                    <tr key={ideaItem.IdeaId}>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left', width: "96px" }}>{ideaItem.LeanIDForDisplay ? ideaItem.LeanIDForDisplay : ideaItem.pg_projectid}</td>
                                                                        <td className="hidden-xs hidden-sm project_name_overflow" data-toggle="tooltip" style={{ textAlign: 'left' }} title={ideaItem.msdyn_subject}>{ideaItem.msdyn_subject ? ideaItem.msdyn_subject : "-"}</td>
                                                                        <td style={{ textAlign: 'left' }}>{ideaItem.pg_worktypetxt ? ideaItem.pg_worktypetxt : "-"}</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_projectstate ? ideaItem.pg_projectstate : "-" }</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_statuscode ? ideaItem.pg_statuscode : "-"}</td>
                                                                        <td style={{ textAlign: 'left' }}>{ideaItem.pg_projowner ? ideaItem.pg_projowner : "-"}</td>
                                                                        <td style={{ textAlign: 'left' }}>{ideaItem.pg_mentor ? ideaItem.pg_mentor : "-"}</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_account ? ideaItem.pg_account : "-"}</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_vertical ? ideaItem.pg_vertical : "-"}</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_region ? ideaItem.pg_region : "-"}</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_segment ? ideaItem.pg_segment : "-"}</td>
                                                                        <td className="hidden-xs hidden-sm" style={{ textAlign: 'left' }}>{ideaItem.pg_unit ? ideaItem.pg_unit : "-"}</td>
                                                                        <td><button onClick={() => this.handleIdeaAction(ideaItem.pg_projectid, ideaItem.IdeaId, ideaItem.LeanIDForDisplay)} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-hover-custom-color-6 u-radius-6 u-btn-2 new-btn-style" style={{ minWidth: 60, borderRadius: 0, margin:"auto" }}>Review</button></td>

                                                                    </tr>
                                                                )
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="100%"> No items found! </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default ProductivityAdminListPage





